import { render, staticRenderFns } from "./CytologyLabTests.vue?vue&type=template&id=40393508&scoped=true&"
import script from "./CytologyLabTests.vue?vue&type=script&lang=js&"
export * from "./CytologyLabTests.vue?vue&type=script&lang=js&"
import style0 from "./CytologyLabTests.vue?vue&type=style&index=0&id=40393508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40393508",
  null
  
)

export default component.exports